const initState = {
    projectDatastore: {

    },
}

const datastoreReducer = (state = initState, action) => {
    if (action.type === "ADD_FLOOR_MARKERS_PROJECT_DATASTORE") {
        return {
            ...state,
        }
    }

    else if (action.type === "TEST_ADD_FLOOR_MARKERS_PROJECT_DATASTORE") {
        return {
            ...state,
            projectDatastore: action.projectDatastore,
        }
    }

    return state;
}

export default datastoreReducer;